import { styled } from "@styles";

export const FeedbackContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  height: "$20px",
  fontSize: "$xs",
  lineHeight: "100%",
  color: "$content-2",

  svg: {
    marginRight: "$8px",
  },

  variants: {
    variant: {
      system: {
        lineHeight: "1rem",
      },
      core: {
        lineHeight: "1rem",
      },
    },
    type: {
      success: {
        color: "$green40",
      },
      error: {
        color: "$red40",
        line: {
          stroke: "$red40 !important",
        },
      },
      core: {},
    },
  },

  compoundVariants: [
    {
      variant: "system",
      type: "error",
      css: {
        color: "$dangerRed",

        line: {
          stroke: "$dangerRed !important",
        },
      },
    },
  ],
});

export const FeedbackMessage = styled("span", {});
